export default __webpack_public_path__ + "static/media/footer-phone-ICN.9a1c7c18.svg";